export default __webpack_public_path__ + "static/media/feature-image1.7fdbaac1.png";